import { useEffect, useState } from "react";
import { startOfLocalDay } from "../utils/runTimeBuckets";

/**
 * The start of the viewer's local today, so "Today" becomes "Yesterday" just
 * after midnight while the page stays open.
 *
 * It checks the clock every `intervalMs`, but the value is the same number
 * all day and React skips a re-render when a state value hasn't changed, so
 * the page re-renders only when the local date changes. A plain poll also
 * covers sleep and wake, DST and a time-zone change while travelling.
 *
 * @param {number} [intervalMs=60000]
 * @returns {number} epoch milliseconds of local midnight today
 */
export default function useToday(intervalMs = 60 * 1000) {
  const [today, setToday] = useState(() => startOfLocalDay(Date.now()));

  useEffect(() => {
    const id = setInterval(
      () => setToday(startOfLocalDay(Date.now())),
      intervalMs,
    );
    return () => clearInterval(id);
  }, [intervalMs]);

  return today;
}
